const titles: Record<string, string> = {
  Home: 'Startseite', Chats: 'Chats', 'Saved Characters': 'Gespeicherte Charaktere',
  'Membership Plans': 'Abos', Audiobooks: 'Hörbücher', Settings: 'Einstellungen',
  'Log In': 'Anmelden', 'Sign Up': 'Registrieren', Support: 'Hilfe',
  'Terms of Service': 'Nutzungsbedingungen', 'Privacy Policy': 'Datenschutzerklärung',
  'Payment Complete': 'Zahlung abgeschlossen', 'Book Talk': 'Buchgespräch', Chat: 'Chat',
};

export function localizedPageTitle(title: string, language: 'en' | 'de'): string {
  if (language !== 'de') return title;
  const suffix = ' | Bookish Boyfriend';
  if (!title.endsWith(suffix)) return title;
  const label = title.slice(0, -suffix.length);
  const chat = /^(Chat|Book Talk) with (.+)$/.exec(label);
  if (chat) return `${chat[1] === 'Chat' ? 'Chat' : 'Buchgespräch'} mit ${chat[2]}${suffix}`;
  return `${titles[label] || label}${suffix}`;
}
